import { BaseResults } from 'libs/searchspring/components/recommendations/BaseResults'

export function GridResults({
  className,
  wrapperClassName = '',
  productCardOptions
}) {
  return (
    <BaseResults
      className={className}
      wrapperClassName={`${wrapperClassName} flex-wrap`}
      productCardOptions={productCardOptions}
    />
  )
}
